const StrateOffresConnecteursClesEnMain = {
    init() {
        const breakpointResponsive = 1024;
        const strate = $('.strate-offres-connecteurs-cles-en-main');
        
        // si la strate existe
        if (strate) {
            const sliderItem = $('.strate-offres-connecteurs-cles-en-main .inner_content_strate_offres_connecteurs_cles_en_main .inner_content_wrapper .connecteur');
            const sliderWrapper = $('.strate-offres-connecteurs-cles-en-main .inner_content_strate_offres_connecteurs_cles_en_main .inner_content_wrapper .connecteurs');

            if ($(window).width() < breakpointResponsive) {
                if (sliderItem.length > 1) {
                    StrateOffresConnecteursClesEnMain.build(sliderWrapper);
                }
            }

            $(window).resize(
                function () {
                    if ($(window).width() < breakpointResponsive) {
                        StrateOffresConnecteursClesEnMain.build(sliderWrapper);
                    } else {
                        StrateOffresConnecteursClesEnMain.destroy(sliderWrapper);
                    }
                }
            );
        }
    },

    build(sliderWrapper) {
        sliderWrapper = sliderWrapper.addClass('owl-carousel');

        sliderWrapper.owlCarousel(
            {
                loop: true,
                margin: 20,
                items: 1,
                center: true,
                nav: false,
                dots: true,
                stagePadding: 0,
                autoWidth: false,
            }
        );
    },

    destroy(sliderWrapper) {
        sliderWrapper.trigger('destroy.owl.carousel');
        sliderWrapper.removeClass('owl-carousel');
    },
};

export default StrateOffresConnecteursClesEnMain;
